/// <reference path="../modules/blocks.storage.module.ts" />
/// <reference path="../objects/classes/storagebase.ts" />

module Blocks {
    export class SessionCookieStorage implements App.Interfaces.IStorageBase {
        static factoryId: string = "sessionCookieStorageFactory";

        constructor(private $cookie: angular.cookies.ICookiesService) {
            
        }

        get<T>(key: string, defaultValue?: T): T {
            var result = this.$cookie.getObject<T>(key);
            if (result && !angular.isUndefined(result))
                return result;
            return defaultValue;
        }
        set<T>(key: string, value: T, params?: { [key: string]: string | number }): void {
            var setParams = angular.merge({ path: '/' }, params || {});
            if (value)
                this.$cookie.putObject(key, value, setParams);
            else if (this.$cookie.get(key)) {
                this.$cookie.remove(key, setParams);
                if (this.$cookie.get(key)) {
                    this.$cookie.putObject(key, null, setParams);
                }
            }
        }
    }
    
    Blocks.storage.factory(SessionCookieStorage.factoryId, ['$cookies', ($cookies) => new SessionCookieStorage($cookies)]);
}